"use client";

import { useCallback, useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import { useTracking } from "../../hooks";
import { useCmp } from "./context";

export type CMPVisibilityTypes = "show" | "hidden" | "byCookieValue";

export const CMP = () => {
  const cmp = useCmp();
  const tracking = useTracking();

  const handleOpenCmp = useCallback(() => {
    cmp.setVisibility("show");
  }, [cmp]);

  useEffect(() => {
    document.addEventListener("open-cmp", handleOpenCmp);
    return () => {
      document.removeEventListener("open-cmp", handleOpenCmp);
    };
  }, [handleOpenCmp]);

  const handleAcceptCookie = () => {
    tracking.initialize();
    cmp.setVisibility("hidden");
  };

  const handleDeclineCookie = () => {
    tracking.untrack();
    cmp.setVisibility("hidden");
  };

  return (
    <CookieConsent
      enableDeclineButton
      onAccept={handleAcceptCookie}
      onDecline={handleDeclineCookie}
      visible={cmp.visibility}
      buttonText="Acepto"
      declineButtonText="Declino"
      ariaAcceptLabel="Aceptar cookies"
      ariaDeclineLabel="Declinar cookies"
    >
      Esta web utiliza cookies para analizar y mejorar la experiencia de
      usuario.
    </CookieConsent>
  );
};
